import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";
import { GlobalState } from "little-state-machine";

export const updateCreateItemOrderPageOrigination = (
  state: GlobalState,
  createItemOrderPageOrigination
  : RoutePathsEnum
) => ({
  ...state,
  createItemOrderPageOrigination
});
